import { push } from 'connected-react-router';
import { call, put, select, takeEvery, all } from 'redux-saga/effects';
import { SetUserInfo, SetUserSubs } from '../actions/auth';
import { CHECK_USER_INFO, LOGOUT } from '../constants/action-types/auth';
import { makeSelectIdTkn, makeSelectProfile } from '../selectors/auth';
import auth0Client from '../utils/auth0Client';

import subscriptionApi from '../utils/subscriptionApi';

// Utils
function* createHeader(opts = {}) {
  const idToken = yield select(makeSelectIdTkn());
  const options = JSON.parse(JSON.stringify(opts));
  options.headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${idToken}`,
  };
  return options;
}

export function* GetUser(uid) {
  // Get a user's current subscription information
  const reqSuf = `/user/${uid}`;
  const options = yield call(createHeader);
  const resp = yield call(subscriptionApi.get, reqSuf, options);
  yield put(SetUserSubs(resp.data.message));
}

export function* requestInfo() {
  try {
    const profile = yield select(makeSelectProfile());
    yield put(SetUserInfo(profile));
    // Get user from scandiumseerver here.
    // If this call is too much work, there is a copy of the user's subscriptions in their profile
    yield GetUser(profile.sub);
    yield put(push('/'));
  } catch (err) {
    // TODO: ivan.santos - report error to sentry
    //    console.log('err', err);
  }
}

export function* logout() {
  try {
    yield auth0Client.signOut();
  } catch (err) {
    // TODO: ivan.santos - report error to sentry
    //    console.log('err', err);
  }
}

function* watchCheckUserInfo() {
  yield takeEvery(CHECK_USER_INFO, requestInfo);
}

function* watchLogout() {
  yield takeEvery(LOGOUT, logout);
}

export default function* authSagas() {
  yield all([watchCheckUserInfo(), watchLogout()]);
}
